import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setPackEligibility } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useConfiguration } from "@app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const usePackSellEligibilityAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (parent_vetic_variant_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res = await axios.get(
          `${INVENTORY_MODULE?.PACK_SELL_ELIGILIBILITY?.baseURL}?parent_vetic_variant_id=${parent_vetic_variant_id}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          dispatch(setPackEligibility(res.data.data));
        } else {
          dispatch(setPackEligibility(null));
        }
        return res.data;
      } catch (e: any) {
        captureError(e);
        sendCurl(e.config["curlCommand"]);
        dispatch(setPackEligibility(null));
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );

  return { execute };
};
